import { ethers } from "ethers"
import { API_URL, web3ChainId, web3ChainName } from "../../constants/constants"
import {
  checkApprove,
  getDecimals,
  getNetwork,
  getSigner,
  getVaultContract,
} from "../../data/smart"
import { formatMetamaskError } from "../../utils/utlis"

export const handleJoinTournament = async (
  user,
  tournamentId,
  entryFee,
  paymentSource = "wallet",
) => {
  if (!window.ethereum) return alert("Metamask not found")

  const chainId = (await getNetwork()).chainId.toString()

  if (chainId !== web3ChainId) {
    throw new Error(`Please switch to the "${web3ChainName}".`)
  }

  // проверяем Entry Fee на подмену
  const data = await tournamentEntryFeeCheck(
    user.sessionToken,
    tournamentId,
    entryFee,
  )

  if (!data.success) {
    throw new Error(data.error)
  }

  if (!data.result) {
    throw new Error("Tournament entry fee check failed")
  }

  // определяем с какого баланса нужно списать средства
  let type, receipt

  try {
    if (paymentSource === "balance") {
      type = "TournamentJoinViaBalance"
      receipt = await handleJoinTournamentViaBalance(
        user.address,
        tournamentId,
        entryFee.toString(),
      )
    } else {
      type = "TournamentJoinViaWallet"
      receipt = await handleJoinTournamentViaWallet(
        user.address,
        tournamentId,
        entryFee.toString(),
      )
    }
  } catch (e) {
    throw new Error(formatMetamaskError(e))
  }

  // сохраняем транзакцию
  await fetch(`${API_URL}/web3/transactions/save`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${user.sessionToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      hash: receipt.transactionHash,
      chain_id: chainId,
      sum: entryFee,
      type: type,
      payload: {
        tournament_id: tournamentId,
      },
    }),
  })

  return "You have successfully joined the tournament"
}

const handleJoinTournamentViaBalance = async (
  userAddress,
  tournamentId,
  entryFee,
) => {
  const decimals = await getDecimals()
  const amount = ethers.utils.parseUnits(entryFee, decimals)
  const signer = await getSigner()
  const vaultContract = await getVaultContract()

  // Проверяем внутренний баланс рефералки на контракте
  const myRef = await vaultContract.referrals(userAddress)

  if (myRef.availableToWithdraw.lt(amount)) {
    throw new Error(
      "There are not enough funds in your internal smart contract balance!",
    )
  }

  // Проверяем Approve
  await checkApprove(amount, userAddress, signer)

  const tx = await vaultContract.depositTournamentViaInternalBalance(
    parseInt(tournamentId),
    amount,
    { gasLimit: 500000 },
  )
  return await tx.wait()
}

const handleJoinTournamentViaWallet = async (
  userAddress,
  tournamentId,
  entryFee,
) => {
  const decimals = await getDecimals()
  const amount = ethers.utils.parseUnits(entryFee, decimals)
  const signer = await getSigner()
  const vaultContract = await getVaultContract()

  // Проверяем Approve
  await checkApprove(amount, userAddress, signer)

  const tx = await vaultContract.depositTournamentViaMetaMask(
    parseInt(tournamentId),
    amount,
    { gasLimit: 500000 },
  )
  return await tx.wait()
}

/**
 * Check if user has enough entry fee for tournament
 * @param {string} sessionToken - User session token
 * @param {string} tournamentId - Tournament ID
 * @param {number} entryFee - Entry fee amount
 * @returns {Promise<{success: boolean, result: boolean, error?: string}>} Server response.
 */
const tournamentEntryFeeCheck = async (
  sessionToken,
  tournamentId,
  entryFee,
) => {
  try {
    const response = await fetch(
      `${API_URL}/tournaments/entry_fee_check/${tournamentId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionToken ? `Bearer ${sessionToken}` : "",
        },
        body: JSON.stringify({ entry_fee: entryFee }),
      },
    )

    return await response.json()
  } catch (error) {}
}
